module.exports = __webpack_public_path__ + "static/media/06-David.fcdd9d9b.jpg";